'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _Legend = require('./Legend');

var _Legend2 = _interopRequireDefault(_Legend);

var _constants = require('../../../rules/src/constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSymbolSeriesItems = function getSymbolSeriesItems(_ref) {
  var data = _ref.data,
      options = _ref.options;

  var symbolMarkers = R.path(['serie', 'symbol', 'markers'], options);
  var nMarkers = R.length(symbolMarkers);
  var markerSize = Number(R.path(['serie', 'symbol', 'markerDefaultSize'], options));
  var strokeWidth = R.path(['serie', 'symbol', 'markerDefaultStrokeWidth'], options);
  var size = Math.round(Math.sqrt(markerSize)) + 8;
  return R.pipe(R.pathOr([], ['series', 0, 'symbolValues']), R.addIndex(R.map)(function (label, serieIndex) {
    var marker = R.nth(serieIndex % nMarkers, symbolMarkers);
    return {
      d: marker.path(markerSize),
      transform: 'translate(' + size / 2 + ', ' + size / 2 + ') rotate(' + R.propOr(0, 'rotate', marker) + ')',
      style: R.pipe(R.mergeRight({ strokeWidth: strokeWidth }), R.when(function (s) {
        return s.fill !== s.stroke;
      }, R.assoc('fill', 'white')))(marker.style),
      size: size,
      label: label
    };
  }))(data);
};

var getStackedSeriesItems = R.pipe(R.pathOr([], ['options', 'serie', 'stacked', 'layerSeries']), R.when(function (s) {
  return R.length(s) === 1;
}, R.always([])));

var stackedLayerRenderer = function stackedLayerRenderer(_ref2) {
  var baseColor = _ref2.baseColor;
  return _react2.default.createElement(
    'svg',
    { width: '21', height: '14' },
    _react2.default.createElement('rect', { x: '0', y: '0', width: '21', height: '14', fill: baseColor })
  );
};

var symbolRenderer = function symbolRenderer(_ref3) {
  var d = _ref3.d,
      size = _ref3.size,
      style = _ref3.style,
      transform = _ref3.transform;
  return _react2.default.createElement(
    'svg',
    { width: size, height: size },
    _react2.default.createElement('path', (0, _extends3.default)({
      d: d,
      transform: transform
    }, style))
  );
};

// stacked entries = [{ label, color }];

var SeriesLegend = function SeriesLegend(_ref4) {
  var data = _ref4.data,
      options = _ref4.options,
      type = _ref4.type;

  var itemRenderer = R.pipe(R.when(R.always(type === _constants.H_SYMBOL || type === _constants.V_SYMBOL), R.always(symbolRenderer)), R.when(R.always(type === _constants.STACKED_BAR || type === _constants.STACKED_ROW), R.always(stackedLayerRenderer)))(null);

  if (R.isNil(itemRenderer)) {
    return null;
  }

  var seriesItems = R.pipe(R.when(R.always(type === _constants.H_SYMBOL || type === _constants.V_SYMBOL), getSymbolSeriesItems), R.when(R.always(type === _constants.STACKED_BAR || type === _constants.STACKED_ROW), getStackedSeriesItems))({ data: data, options: options });

  return _react2.default.createElement(_Legend2.default, { items: seriesItems, itemRenderer: itemRenderer });
};

SeriesLegend.propTypes = {
  data: _propTypes2.default.object,
  options: _propTypes2.default.object,
  type: _propTypes2.default.string
};

exports.default = SeriesLegend;